export const ESTIMATION_API_URI = '/rest/greenhopper/1.0/rapidviewconfig/estimation';
